<form *ngIf="form" [formGroup]="form" class="form form-additionalAddress">
  <div class="form-body">
    <div class="form-section">
      <div class="form-additionalAddress-inner">
        <div *ngIf="canUpdateObjekt" class="form-additionalAddress-actions">
          <button class="btn btn_link btn_delete" (click)="onAddressRemoval()" svgIcon [icon]="'delete'">
          </button>
        </div>
        <div class="collapseArea">
          <div class="collapseArea-trigger d-flex justify-content-between" (click)="isCollapsed = !isCollapsed"
            [attr.aria-expanded]="!isCollapsed">
            <div>
              <i svgIcon [icon]="'arrow'" [ngClass]="{'_open': !isCollapsed}"></i>
              {{addressTitle | translate}}
            </div>
          </div>
          <div [collapse]="isCollapsed" [isAnimated]="true">
            <div class="collapseArea-body">

              <app-form-row [label]="'FORMS.COMMON.COMPANY_NAME' | translateControl : form | async">
                <app-input [type]="'text'" [mainForm]="form" [controlName]="'companyName'">
                </app-input>
              </app-form-row>

              <app-form-row [label]="'FORMS.COMMON.SALUTATION' | translateControl : form | async">
                <div class="row">
                  <div class="col-6">
                    <app-dropdown [options]="dropdownData.salutation" [labelKey]="'title'" [valueKey]="'value'"
                      [mainForm]="form" [controlName]="'salutation'">
                    </app-dropdown>
                  </div>
                </div>
              </app-form-row>

              <app-form-row
                [label]="['FORMS.COMMON.LAST_NAME', 'FORMS.COMMON.FIRST_NAME'] | translateControl : form | async">
                <div class="row">
                  <div class="col-6">
                    <app-input [type]="'text'" [mainForm]="form" [controlName]="'lastName'">
                    </app-input>
                  </div>
                  <div class="col-6">
                    <app-input [type]="'text'" [mainForm]="form" [controlName]="'firstName'">
                    </app-input>
                  </div>
                </div>
              </app-form-row>

              <app-form-row
                [label]="['FORMS.ADDRESS.STREET_NAME', 'FORMS.ADDRESS.STREET_NR'] | translateControl : addressForm | async">
                <div class="row">
                  <div class="col-8">
                    <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'streetName'">
                    </app-input>
                  </div>
                  <div class="col-4">
                    <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'streetNr'">
                    </app-input>
                  </div>
                </div>
              </app-form-row>

              <app-form-row
                [label]="['FORMS.ADDRESS.ZIP_CODE', 'FORMS.ADDRESS.CITY', 'FORMS.ADDRESS.COUNTRY'] | translateControl : addressForm | async">
                <div class="row">
                  <div class="col-3">
                    <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'zipCode'">
                    </app-input>
                  </div>
                  <div class="col-5">
                    <app-input [type]="'text'" [mainForm]="addressForm" [controlName]="'city'">
                    </app-input>
                  </div>
                  <div class="col-4">
                    <app-dropdown [options]="dropdownData.countries" [labelKey]="'title'" [valueKey]="'value'"
                      [mainForm]="addressForm" [controlName]="'country'" [searchable]="true" [defaultValue]="dropdownData.countries[0].value">
                    </app-dropdown>
                  </div>
                </div>
              </app-form-row>

              <app-form-row [label]="'FORMS.COMMON.EMAIL' | translateControl : form | async">
                <app-input [type]="'text'" [mainForm]="form" [controlName]="'email'">
                </app-input>
              </app-form-row>

              <app-form-row [label]="'FORMS.COMMON.PHONE' | translateControl : form | async">
                <app-input [type]="'text'" [mainForm]="form" [controlName]="'phone'">
                </app-input>
              </app-form-row>

              <app-form-row [label]="'FORMS.COMMON.FAX' | translateControl : form | async">
                <app-input [type]="'text'" [mainForm]="form" [controlName]="'fax'">
                </app-input>
              </app-form-row>

              <app-form-row [label]="'FORMS.COMMON.WEBSITE' | translateControl : form | async">
                <app-input [type]="'text'" [mainForm]="form" [controlName]="'website'">
                </app-input>
              </app-form-row>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
